export default "__VITE_ASSET__DqcIQZKA2wTrpIVzgpbBow__"